




















import { Component, Vue, Prop } from "vue-property-decorator";
const cityData = require("@/assets/pca-code.json");
@Component({})
export default class ResearchListContentJiatingzhuzhi extends Vue {
  private cityOption: any;
  @Prop()
  private content: any;
  /**
   * @description 获取store中的可编辑状态
   */
  private get composeDisabled() {
    return this.$store.state.researchListComposeDiabled;
  }
  /**
   * @description content双向绑定
   */
  private contentChange() {
    this.$emit("update:content", this.content);
  }
  /**
   * @description 加载三级联动数据，加载缓存的验证码等待时间
   */
  private beforeMount() {
    this.cityOption = cityData;
  }
}
